import { Injector } from '@angular/core';

/**
 * use this as global injector
 */
export const AppInjector: {
  injector: Injector;
} = {
  injector: null,
};
